import { useCallback } from 'react';
import ariaAnnouncer from '../utils/ariaAnnouncer';

type AnnouncementPriority = 'polite' | 'assertive';

/**
 * Hook for announcing messages to screen readers
 */
export const useAriaAnnouncer = () => {
  const announce = useCallback((message: string, priority: AnnouncementPriority = 'polite') => {
    ariaAnnouncer.announce(message, priority);
  }, []);

  const clear = useCallback(() => {
    ariaAnnouncer.clear();
  }, []);

  return { announce, clear };
};
